module.exports = __webpack_public_path__ + "static/josefin-sans-latin-300-c3277be1d7599558aff7f652ebc46742.woff";